import { render, staticRenderFns } from "./SaasDraggable.vue?vue&type=template&id=0d778fe2&"
import script from "./SaasDraggable.vue?vue&type=script&lang=js&"
export * from "./SaasDraggable.vue?vue&type=script&lang=js&"
import style0 from "./SaasDraggable.vue?vue&type=style&index=0&id=0d778fe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports